// Theme Core
import './core';
import './global/scroll-to';
import './global/swiper';
import Helper from './global/helpers';

import makeCalcAppHeight from './global/vh-fix';

/* Height fix for mobile browser */
makeCalcAppHeight();

const helper = new Helper();
window.helper = helper;
